/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsUserDashboardParametersResponse
 */
export interface RevisdomAPIViewModelsUserDashboardParametersResponse {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsUserDashboardParametersResponse
     */
    organizationsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsUserDashboardParametersResponse
     */
    usersCount?: number;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsUserDashboardParametersResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsUserDashboardParametersResponse(value: object): value is RevisdomAPIViewModelsUserDashboardParametersResponse {
    return true;
}

export function RevisdomAPIViewModelsUserDashboardParametersResponseFromJSON(json: any): RevisdomAPIViewModelsUserDashboardParametersResponse {
    return RevisdomAPIViewModelsUserDashboardParametersResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserDashboardParametersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsUserDashboardParametersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationsCount': json['organizationsCount'] == null ? undefined : json['organizationsCount'],
        'usersCount': json['usersCount'] == null ? undefined : json['usersCount'],
    };
}

export function RevisdomAPIViewModelsUserDashboardParametersResponseToJSON(json: any): RevisdomAPIViewModelsUserDashboardParametersResponse {
    return RevisdomAPIViewModelsUserDashboardParametersResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserDashboardParametersResponseToJSONTyped(value?: RevisdomAPIViewModelsUserDashboardParametersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organizationsCount': value['organizationsCount'],
        'usersCount': value['usersCount'],
    };
}

